import { api } from './api'
import { Tenant } from './shared-types'

export const getPageBrand = () => api.config.TENANT

export const generateDataByBrand = <T>(data: [T, T, T]) => {
  // data = ['data for ahs', 'data for hsa' , 'data for hbw210']

  if (getPageBrand() === Tenant.HSA) {
    return data[1]
  } else if (getPageBrand() === Tenant.HBW210) {
    return data[2]
  }
  return data[0]
}
